import styled from 'styled-components';

import { NorlysFont } from '~src/branding';
import { boxShadows } from '~src/branding/boxShadow';

export const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: 'fit-content',
  maxWidth: '90%',
});

export const ContainerNorlys = styled(Container)({
  ...boxShadows.norlysButton,
  marginTop: '16px',
  padding: '8px',
});

export const TitleNorlys = styled.div({
  ...NorlysFont.style('heading', 20),
});

export const MobileTitleWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  margin: '8px 0 24px',
});

export const MobileTitleWrapperNorlys = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  margin: '8px 0 24px',
  ...NorlysFont.style('heading', 20),
});

export const GraphWrapperNorlys = styled.div({
  display: 'flex',
  flexFlow: 'row nowrap',
  width: '90%',
  '.recharts-responsive-container': {
    width: 'calc(100% - 224px) !important',
  },
});
